export default "__VITE_ASSET__DkawEp7L__"